const state = {
  currency: [{
      currency_id: 933,
      currency_code: "BYN",
      currency_character: "BYN",
      currency_name_ru: "Белорусский рубль",
      currency_name_en: "Belarusian Ruble"
    },
    {
      currency_id: 906,
      currency_code: "BYN",
      currency_character: "BYN",
      currency_name_ru: "Белорусский рубль",
      currency_name_en: "Belarusian Ruble"
    },
    {
      currency_id: 398,
      currency_code: "KZT",
      currency_character: "₸",
      currency_name_ru: "Тенге",
      currency_name_en: "Tenge"
    },
    {
      currency_id: 643,
      currency_code: "RUB",
      currency_character: "₽",
      currency_name_ru: "Российский рубль",
      currency_name_en: "Russian Ruble"
    },
    {
      currency_id: 810,
      currency_code: "RUB",
      currency_character: "₽",
      currency_name_ru: "Российский рубль",
      currency_name_en: "Russian Ruble"
    },
    {
      currency_id: 51,
      currency_code: "AMD",
      currency_character: "֏",
      currency_name_ru: "Армянский драм",
      currency_name_en: "Armenian Dram"
    },
    {
      currency_id: 417,
      currency_code: "KGS",
      currency_character: "⊆",
      currency_name_ru: "Сом",
      currency_name_en: "Som"
    },
    {
      currency_id: 978,
      currency_code: "EUR",
      currency_character: "€",
      currency_name_ru: "Евро",
      currency_name_en: "Euro"
    },
    {
      currency_id: 840,
      currency_code: "USD",
      currency_character: "$",
      currency_name_ru: "Доллар США",
      currency_name_en: "Dollar USA"
    },
    {
      currency_id: 985,
      currency_code: "PLN",
      currency_character: "PLN",
      currency_name_ru: "Злотый",
      currency_name_en: "Zloty"
    },
    {
      currency_id: 36,
      currency_code: "AUD",
      currency_character: "$",
      currency_name_ru: "Австралийский доллар",
      currency_name_en: "Australian dollar"
    },
    {
      currency_id: 944,
      currency_code: "AZN",
      currency_character: "ман.",
      currency_name_ru: "Азербайджанский манат",
      currency_name_en: "Azerbaijan Manat"
    },
    {
      currency_id: 826,
      currency_code: "GBP",
      currency_character: "£",
      currency_name_ru: "Фунт стерлингов Соединенного королевства",
      currency_name_en: "Pound Sterling"
    },
    {
      currency_id: 975,
      currency_code: "BGN",
      currency_character: "лв.",
      currency_name_ru: "Болгарский лев",
      currency_name_en: "Bulgarian lev"
    },
    {
      currency_id: 986,
      currency_code: "BRL",
      currency_character: "R$",
      currency_name_ru: "Бразильский реал",
      currency_name_en: "Brazilian Real"
    },
    {
      currency_id: 348,
      currency_code: "HUF",
      currency_character: "Ft",
      currency_name_ru: "Венгерскиq форинт",
      currency_name_en: "Forint"
    },
    {
      currency_id: 344,
      currency_code: "HKD",
      currency_character: "HK$",
      currency_name_ru: "Гонконгский доллар",
      currency_name_en: "Forint"
    },
    {
      currency_id: 208,
      currency_code: "DKK",
      currency_character: "kr",
      currency_name_ru: "Датская крона",
      currency_name_en: "Danish Krone"
    },
    {
      currency_id: 356,
      currency_code: "INR",
      currency_character: "Rs.",
      currency_name_ru: "Индийских рупий",
      currency_name_en: "Indian Rupee"
    },
    {
      currency_id: 124,
      currency_code: "CAD",
      currency_character: "CA$",
      currency_name_ru: "Канадский доллар",
      currency_name_en: "Canadian Dollar"
    },
    {
      currency_id: 156,
      currency_code: "CNY",
      currency_character: "¥",
      currency_name_ru: "Китайский юань",
      currency_name_en: "Yuan Renminbi"
    },
    {
      currency_id: 498,
      currency_code: "MDL",
      currency_character: "L",
      currency_name_ru: "Молдавский лей",
      currency_name_en: "Moldovan leu"
    },
    {
      currency_id: 578,
      currency_code: "NOK",
      currency_character: "kr",
      currency_name_ru: "Норвежских крон",
      currency_name_en: "Norwegian Krone"
    },
    {
      currency_id: 946,
      currency_code: "RON",
      currency_character: "lei",
      currency_name_ru: "Румынский лей",
      currency_name_en: "Romanian Leu"
    },
    {
      currency_id: 946,
      currency_code: "RON",
      currency_character: "lei",
      currency_name_ru: "Румынский лей",
      currency_name_en: "Romanian Leu"
    },
    {
      currency_id: 702,
      currency_code: "SGD",
      currency_character: "S$",
      currency_name_ru: "Сингапурский доллар",
      currency_name_en: "Singapore Dollar"
    },
    {
      currency_id: 972,
      currency_code: "TJS",
      currency_character: "сом.",
      currency_name_ru: "Таджикских сомони",
      currency_name_en: "Somoni"
    },
    {
      currency_id: 949,
      currency_code: "TRY",
      currency_character: "TL",
      currency_name_ru: "Турецкая лира",
      currency_name_en: "Turkish Lira"
    },
    {
      currency_id: 934,
      currency_code: "TMT",
      currency_character: "T",
      currency_name_ru: "Новый туркменский манат",
      currency_name_en: "Turkmenistan New Manat"
    },
    {
      currency_id: 860,
      currency_code: "UZS",
      currency_character: "So'm",
      currency_name_ru: "Узбекский сум",
      currency_name_en: "Uzbekistan Sum"
    },
    {
      currency_id: 980,
      currency_code: "UAH",
      currency_character: "грн",
      currency_name_ru: "Украинская гривна",
      currency_name_en: "Hryvnia"
    },
    {
      currency_id: 203,
      currency_code: "CZK",
      currency_character: "Kč",
      currency_name_ru: "Чешская крона",
      currency_name_en: "Czech Koruna"
    },
    {
      currency_id: 752,
      currency_code: "SEK",
      currency_character: "kr",
      currency_name_ru: "Шведская крона",
      currency_name_en: "Swedish Krona"
    },
    {
      currency_id: 756,
      currency_code: "CHF",
      currency_character: "Fr",
      currency_name_ru: "Швейцарский франк",
      currency_name_en: "Swiss Franc"
    },
    {
      currency_id: 710,
      currency_code: "ZAR",
      currency_character: "R",
      currency_name_ru: "Южноафриканский рэнд",
      currency_name_en: "Rand"
    },
    {
      currency_id: 410,
      currency_code: "KRW",
      currency_character: "₩",
      currency_name_ru: "Южнокорейская вона",
      currency_name_en: "Won"
    },
    {
      currency_id: 392,
      currency_code: "JPY",
      currency_character: "¥",
      currency_name_ru: "Японская иена",
      currency_name_en: "Yen"
    },
  ]
}

const getters = {
  currencyList(state) {
    return state.currency
  },
  currencyNameRu: state => id => {
    if (state.currency && state.currency.length > 0 && id != null) {
      return state.currency.find(el => el.currency_id === id)['currency_name_ru']
    } else {
      return ""
    }
  },
  currencyNameEn: state => id => {
    if (state.currency && state.currency.length > 0 && id != null) {
      return state.currency.find(el => el.currency_id === id)['currency_name_en']
    } else {
      return ''
    }
  },
  currencyCharacter: state => id => {
    if (state.currency && state.currency.length > 0 && id != null) {
      let item = state.currency.find(el => el.currency_id === id)
      return (item) ? item['currency_character'] : ""
    } else {
      return ''
    }
  },
}

export default {
  state,
  getters
}